/**
 * useStableProfile — Returns the last non-null profile during brief null gaps.
 *
 * Prevents skeleton flashes when profile briefly becomes null during
 * React re-renders (e.g., tab switching, route changes). Only shows
 * skeleton on genuine cold start (profile has never been available).
 */

import { useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import type { UserProfile } from '@/types';

export function useStableProfile(): {
  profile: UserProfile | null;
  isFirstLoad: boolean;
} {
  const { profile } = useAuth();
  const lastRef = useRef<UserProfile | null>(profile);

  if (profile) {
    lastRef.current = profile;
  }

  return {
    profile: lastRef.current,
    isFirstLoad: !lastRef.current,
  };
}
